module.exports = __webpack_public_path__ + "static/img/share2.69058d9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/share2.gif
// module id = Ohgx
// module chunks = 4